/**
 * MuiAppBar
 *
 * Demos:
 *
 * - [App bar](https://ui-packages.isbuildingluma.com/ui-core/react-app-bar/)
 *
 * API:
 *
 * - [AppBar API](https://ui-packages.isbuildingluma.com/ui-core/api/app-bar/)
 * - inherits [MuiAppBar API](https://mui.com/material-ui/api/app-bar/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Design-System-Playground?type=design&node-id=304-22913&t=wWEUIWiseZ4sbDj9-0)
 */
const MuiAppBar = {
  defaultProps: {
    elevation: 0
  },
  styleOverrides: {
    colorDefault: {
      backgroundColor: 'white'
    }
  }
};
export default MuiAppBar;